import * as types from '../actions/actionTypes';
import {hardCodeIsModerno} from "../misc/fabricatorHardcode";

export const DEFAULT_SLAB_IMAGE_PART = 60;
export const SLAB_IMAGE_TYPES = {
  placeholder: "placeholder",
  upload: "upload"
}
const isModerno = hardCodeIsModerno();

const initialState = {
  isShowSlabTool: false,
  isSlabToolVisited: false,
  isMeasurementVisibleInSlabMode: false,
  roomsWithVisitedSlabTool: [],
  searchText: "",
  activeSlabId: 0,
  selectedImage: "",
  activeStep: 1,
  slabImageType: null,
  slabImageHeight: isModerno ? 0 : 60,
  slabImageWidth: isModerno ? 0 : 126,
  slabAspectRatio: 0,
  croppedSlabImages: [],
  pricePerArea: 0,
  cropperData: {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    rotate: 0,
    scaleX: 0,
    scaleY: 0
  },
  activeSlabUrl: "",
  isSizeValidationFailed: false,
  isSlabPricingEnabled: true,
};

export default function(state = initialState, action) {

  let filteredImages;
  switch(action.type) {
    case types.SHOW_SLAB_TOOL:
    case types.SET_SLAB_TOOL_VISITED:
    case types.SET_ACTIVE_SLAB_ID:
    case types.SET_ACTIVE_SLAB_URL:
    case types.SET_SQFT_SLAB_SEARCH_TEXT:
    case types.SET_SQFT_SLAB_ASPECT_RATIO:
    case types.SET_SQFT_SLAB_IMAGE_WIDTH:
    case types.SET_SQFT_SLAB_IMAGE_HEIGHT:
    case types.SET_SQFT_SLAB_ACTIVE_STEP:
    case types.SET_SQFT_SLAB_CROPPER_DATA:
    case types.SET_PRICE_PER_AREA:
    case types.SET_SLAB_IMAGE_TYPE:
    case types.SET_IS_MEASUREMENT_VISIBLE_IN_SLAB_MODE:
    case types.SET_IS_SIZE_VALIDATION_FAILED:
    case types.SET_IS_SLAB_PRICING_ENABLED:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_SQFT_CROPPED_SLAB_IMAGES:
      state = {...state, croppedSlabImages: action.payload.croppedSlabImages};
      break;
    case types.ADD_SQFT_CROPPED_SLAB_IMAGE:
      return Object.assign({}, state, {
        croppedSlabImages: [...state.croppedSlabImages, action.payload]
      });
    case types.ADD_ROOM_WITH_VISITED_SLAB_TOOL:
      if (!state.roomsWithVisitedSlabTool.includes(action.payload)) {
        return Object.assign({}, state, {
          roomsWithVisitedSlabTool: [...state.roomsWithVisitedSlabTool, action.payload]
        });
      }
      return state
    case types.DELETE_CROPPED_SLAB_IMAGE:
      filteredImages = state.croppedSlabImages.filter((row) => row.id !== action.payload.id);

      return Object.assign({}, state, {
        croppedSlabImages: filteredImages
      });

  }

  return state;
}
